"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.deserializeQuery = function (queryString, config) {
    var partialQuery = queryString
        .replace(/^\?/, '')
        .split('&')
        .reduce(function (acc, part) {
        var split = part.split('=');
        var parameterName = decodeURIComponent(split[0]);
        var parameterValue = decodeURIComponent(split[1]);
        if (parameterName) {
            if (config && config.parameters[parameterName]) {
                acc[parameterName] = config.parameters[parameterName].deserialize(parameterValue);
            }
            else {
                acc[parameterName] = String(parameterValue);
            }
        }
        return acc;
    }, {});
    // replace with default values
    var query = partialQuery;
    if (config) {
        query = Object.keys(config.parameters).reduce(function (acc, parameterName) {
            if (!(parameterName in acc)) {
                acc[parameterName] = config.parameters[parameterName].deserialize('');
            }
            return acc;
        }, query);
    }
    return query;
};
exports.serializeQuery = function (query, config) {
    var search = Object.keys(query)
        .sort()
        .reduce(function (acc, parameterName) {
        var parameterValue = query[parameterName];
        if (config && config.parameters[parameterName]) {
            acc.push(encodeURIComponent(parameterName) + "=" + encodeURIComponent(config.parameters[parameterName].serialize(parameterValue)));
        }
        else {
            acc.push(encodeURIComponent(parameterName) + "=" + encodeURIComponent(String(parameterValue)));
        }
        return acc;
    }, []);
    return "?" + search.join('&');
};
function default_1(search, onQueryChange, config) {
    var query = react_1.default.useMemo(function () { return exports.deserializeQuery(search, config); }, [
        search,
        config,
    ]);
    var handleQueryChange = react_1.default.useCallback(function (parameters) {
        return onQueryChange(exports.serializeQuery(__assign({}, query, parameters), config));
    }, [query, config]);
    var serializedQuery = react_1.default.useMemo(function () { return exports.serializeQuery(query, config); }, [
        query,
        config,
    ]);
    return {
        query: query,
        setQuery: handleQueryChange,
        serializedQuery: serializedQuery,
    };
}
exports.default = default_1;
exports.StringParam = function (defaultValue) { return ({
    serialize: function (v) { return v; },
    deserialize: function (v) { return (v ? v : defaultValue); },
}); };
exports.NumberParam = function (defaultValue) { return ({
    serialize: function (v) { return String(v); },
    deserialize: function (v) {
        var n = Number(v);
        return n ? n : defaultValue;
    },
}); };
exports.ArrayParam = function (itemQuery, defaultValue, separator) {
    if (separator === void 0) { separator = ','; }
    return ({
        serialize: function (v) { return v.map(itemQuery.serialize).join(separator); },
        deserialize: function (v) {
            return v ? v.split(separator).map(itemQuery.deserialize) : defaultValue;
        },
    });
};
exports.PageParam = function (base) {
    if (base === void 0) { base = 1; }
    return ({
        serialize: function (v) { return String(v); },
        deserialize: function (v) {
            var n = Number(v);
            return n && n > base ? n : base;
        },
    });
};
//# sourceMappingURL=index.js.map